module.exports = __webpack_public_path__ + "static/media/workshop_pending_emptystate.08a47fda.svg";